import {
  APPLE_SIGNUP_PROFILE_COOKIE,
  type AppleSignupProfile,
  decodeAppleSignupProfileCookie,
} from '../../../../auth/oauth/apple-signup-profile-cookie.js';

/**
 * The name Apple form-posted to the callback, when it was stored for this
 * login's subject. The cookie is left to expire on its own (ten minutes): a
 * retry after a failed login still has the name Apple will not send again,
 * and the subject binding keeps it off every other account.
 */
export function readAppleSignupProfile(sub: string): AppleSignupProfile | null {
  const prefix = `${APPLE_SIGNUP_PROFILE_COOKIE}=`;
  const entry = document.cookie.split('; ').find((cookie) => cookie.startsWith(prefix));
  return entry === undefined
    ? null
    : decodeAppleSignupProfileCookie(entry.slice(prefix.length), sub);
}
